module.exports = __webpack_public_path__ + "static/media/excel.d97a1cea.svg";